import axios from "axios";
import { getEnvVar } from "../config";

const SERVICES_URL = getEnvVar("REACT_APP_SERVICES_URL") + "/api";

export const getUserInfoV2 = () => {
  const url = SERVICES_URL + "/login/user";
  return axios.get(url).then(response => response.data);
};
